import React, { useState } from 'react';
import {
  Button,
  Space,
  Row,
} from 'antd';
import { LeftOutlined, RightOutlined } from '@ant-design/icons';

import { LIMIT_RECORDS } from '../Utils/constants';

const Pagination = ({ size, onChange = () => { } }) => {
  const [page, setPage] = useState(1);

  const handleOnChange = (newPage, action) => {
    onChange(action, newPage);
    setPage(newPage);
  }

  return (
    <Row justify='end' align="middle" style={{ marginTop: 10, marginBottom: 10 }}>
      <Space size="middle">
        <Button icon={<LeftOutlined />} disabled={page < 2} onClick={() => handleOnChange(page - 1, 'prev')} />
        <Button>{page}</Button>
        <Button icon={<RightOutlined />} disabled={size < LIMIT_RECORDS} onClick={() => handleOnChange(page + 1, 'next')} />
      </Space>
    </Row>
  );
}

export default Pagination;